import { ColorPicker } from '@/components/ColorPicker';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import ColorBrush from '@/images/ColorBrush.svg';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { isStoreImageBackground } from './utils';

const ColorsPalette = styled.div`
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
`;

const Color = styled.div<{ selected: boolean; color: string }>`
    width: 32px;
    height: 32px;
    border-radius: 2px;
    background: ${({ color }) => color};
    cursor: pointer;
    border: ${({ selected, theme }) => `1px solid ${selected ? theme.colors.primary.main : theme.colors.black[200]}`};
`;

const StyledMaskedIcon = styled(MaskedIcon)<{ color: string }>`
    background-color: ${({ color, theme }) => (color.includes('000') ? 'white' : theme.colors.black[900])};
`;

interface Props {
    value: string;
    onChange: (color: string) => void;
}

const DEFAULT_COLORS = ['#FFFFFF', '#8D7DC0', '#7DA0C0', '#7DC0BC', '#9DBAA2', '#9DC1B9', '#EFD0A7', '#D2A98C', '#D28C9A', '#D28CC7'];

export const ColorControl = observer(({ value, onChange }: Props) => {
    const handleChange = (color: string) => {
        const shortColor = color.substring(0, 7);
        onChange(shortColor);
    };

    const DefaultColors = DEFAULT_COLORS.map(hexColor => {
        return <Color key={hexColor} color={hexColor} onClick={() => handleChange(hexColor)} selected={hexColor === value} />;
    });

    const color = getColor(value);

    return (
        <ColorsPalette>
            <ColorPicker value={color} onChange={handleChange} size="32px">
                <StyledMaskedIcon src={ColorBrush} size="18px" color={color} />
            </ColorPicker>
            {DefaultColors}
        </ColorsPalette>
    );
});

const getColor = (background?: string) => {
    const defaultColor = '#FFFFFF';

    if (!background) {
        return defaultColor;
    }

    if (isStoreImageBackground(background)) {
        return defaultColor;
    }

    return background;
};
